import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend/cjs";
import LanguageDetector from "i18next-browser-languagedetector";
import config from "./config.json";
import { localizationBackend } from "common/src/helpers/localizationBundle";

const detectionOptions = {
  order: ["path", "localStorage", "sessionStorage"],
  lookupFromPathIndex: 0,
  lookupLocalStorage: "i18nextLng",
  lookupSessionStorage: "i18nextLng",
};

i18n
  .use(Backend)
  // pass the i18n instance to react-i18next.
  .use({
    type: "postProcessor",
    name: "unescapeHtml",
    process: function (value /*key, options, translator */) {
      var doc = new DOMParser().parseFromString(value, "text/html");
      var bodyHtml = doc.body.innerHTML;
      return bodyHtml;
      //return doc.body.innerHTML;
    },
  })
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    whitelist: ["en", "sv", "fi", "no"],
    // lng: localStorage.getItem('i18nextLng') || 'en',
    ns: [config.skin],
    load: "languageOnly",
    defaultNS: config.skin,
    fallbackLng: config.defaultLang,
    detection: detectionOptions,
    backend: localizationBackend,

    debug: false,

    postProcess: ["unescapeHtml"],

    keySeparator: false, // we do not use keys in form messages.welcome

    // i18next 23+ defaults to false: a null translation would show its key
    returnNull: true,

    react: {
      useSuspense: true,
      bindI18nStore: "added",
    },

    cache: {
      enabled: true,
      expirationTime: 24 * 60 * 60 * 1000,
    },
    caches: ["localStorage", "cookie"],

    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18n;
